import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MbCategoryNavigationToolsComponent } from '../mb-category-navigation-tools.component'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { triggerSmoothCollapseAnimation } from '../../../../../shared/animations/smooth-collapse.animation'
import { map } from 'rxjs/operators'

@Component({
  selector: 'mb-category-navigation-tools-mobile',
  templateUrl: './mb-category-navigation-tools-mobile.component.html',
  styleUrls: ['./mb-category-navigation-tools-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [triggerSmoothCollapseAnimation]
})
export class MbCategoryNavigationToolsMobileComponent extends MbCategoryNavigationToolsComponent {

  @Input() set isMobileNavigationOpened (isMobileNavigationOpened: boolean | null) {
    this.isMobileNavigationOpened$.next(!!isMobileNavigationOpened)
  }

  isMobileNavigationOpened$ = new BehaviorSubject(false)
  isExpanded$ = new BehaviorSubject(false)

  state$ = combineLatest([
    this.isMobileNavigationOpened$,
    this.isExpanded$,
    this.supportsAccountCreation$,
    this.userIsLoggedIn$,
    this.supportsGuestCheckout$
  ]).pipe(
    map(([isMobileNavigationOpened, isExpanded, supportsAccountCreation, userIsLoggedIn, supportsGuestCheckout]) => ({
      isMobileNavigationOpened,
      isExpanded,
      supportsAccountCreation,
      userIsLoggedIn,
      supportsGuestCheckout
    } as MbCategoryNavigationToolsMobileState)))
}

export interface MbCategoryNavigationToolsMobileState {
  isMobileNavigationOpened: boolean;
  isExpanded: boolean;
  supportsAccountCreation: boolean;
  userIsLoggedIn: boolean;
  supportsGuestCheckout: boolean;
}
